import { render, staticRenderFns } from "./ScharffLogo.vue?vue&type=template&id=97113e8a&"
import script from "./ScharffLogo.vue?vue&type=script&lang=js&"
export * from "./ScharffLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports